import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import CheckIcon from "../../../../../../icons/CheckIcon";
import { Input } from "../../../../../../shadcn/components/ui/input";
import { BetaForm as useBetaForm } from "@reusejs/react";
import {
  addBidderForEvent,
  fetchIDCardDetails,
  handleBackendValidationsForBidderCreation,
} from "services/bidder";
import { Button } from "../../../../../../shadcn/components/ui/button";
import { useRouter } from "next/router";
import jbValidateBidders from "./JBValidateBidders";
import { getAuctionEventById } from "services";
import createJBPayload from "./createJBPayload";
import { InfoIcon } from "lucide-react";
import { Switch } from "../../../../../../shadcn/components/ui/switch";

const isDigioPanFullVerificationEnabled =
  process.env.NEXT_PUBLIC_DIGIO_PAN_FULL_VERIFICATION_ENABLED === "true";

interface JBOnlineFormProps {
  setActiveStep: any;
  activeStep: any;
  allBiddersData: any;
  currentBidderData: any;
  setCurrentBidderData: any;
  totalSteps: any;
  eventData: any;
  allErrorsData: any;
  setAllErrorsData: any;
  setOpenOfflineInfoModel: any;
  setKycMode: any;
  kycMode: any;
}

export default function JBOnlineForm({
  setActiveStep,
  activeStep,
  allBiddersData,
  currentBidderData,
  setCurrentBidderData,
  totalSteps,
  eventData,
  setAllErrorsData,
  allErrorsData,
  setOpenOfflineInfoModel,
  setKycMode,
  kycMode,
}: JBOnlineFormProps) {
  const router = useRouter();
  // const { for_event, bidders_count, id } = router.query;
  console.log("allErrorsData", allErrorsData);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{3,}$/;
  const mobileNumberRegEx: RegExp = /^[0-9]{10}$/;
  const panRegex: RegExp = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  // const aadharRegex: RegExp = /^[0-9]{12}$/;
  const [isFetchingPan, setIsFetchingPan] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isNameVerified, setIsNameVerified] = useState(false);

  // V4 name-first flow: debounce ref for PAN verification trigger
  const panVerificationTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Debounced function to trigger PAN verification when name >= 3 chars
  const triggerPanVerification = () => {
    if (panVerificationTimeoutRef.current) {
      clearTimeout(panVerificationTimeoutRef.current);
    }
    panVerificationTimeoutRef.current = setTimeout(() => {
      const nameValue = form?.getField?.("name");
      const panValue = form?.getField?.("pan");

      // Only trigger if name >= 3 AND PAN has value
      if (
        nameValue &&
        nameValue.length >= 3 &&
        panValue &&
        panValue.length >= 10 &&
        isDigioPanFullVerificationEnabled
      ) {
        handlePanFieldValidationsInternal(
          { target: { value: panValue } },
          form,
          setIsFetchingPan,
          setIsNameVerified,
        );
      }
    }, 500);
  };
  // const [currentBranch, setCurrentBranch] = useState<any>(null);
  // const [membersEmail, setMembersEmail] = useState<any>([]);
  const prevBidderData = useRef<any>(null);
  const form = useBetaForm({
    user_type: { label: "Individual", value: "individual" },
    email: "",
    name: "",
    mobile_number: "",
    pan: "",
  });
  const auctionVerifiedData = [
    { label: "Verified Property", value: "auction_verified" },
  ];
  const form_constraints = useMemo(() => {
    return {
      email: {
        presence: {
          allowEmpty: false,
        },
        email: true,
        // exclusion: membersEmail,
      },
      name: {
        presence: {
          allowEmpty: false,
        },
      },
      pan: {
        presence: {
          allowEmpty: false,
        },
        format: {
          pattern: panRegex,
          message: "^PAN number is not valid.",
        },
      },
      // aadhar_number: {
      //   presence: {
      //     allowEmpty: true,
      //   },
      //   format: {
      //     pattern: aadharRegex,
      //     message: "^Aadhar number is not valid.",
      //   },
      // },
      mobile_number: {
        presence: {
          allowEmpty: false,
        },
        format: {
          pattern: mobileNumberRegEx,
          message: "^Mobile number is not valid.",
        },
      },
      user_type: {
        presence: {
          allowEmpty: false,
        },
      },
    };
  }, []);

  const clearFormErrors = () => {
    form.setErrors({});
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, [form_constraints, form]);

  useEffect(() => {
    if (
      currentBidderData &&
      JSON.stringify(currentBidderData) !==
        JSON.stringify(prevBidderData.current)
    ) {
      clearFormErrors();
      form.setField(
        "user_type",
        currentBidderData?.user_type || {
          label: "Individual",
          value: "individual",
        },
      );
      form.setField("email", currentBidderData?.email || "");
      form.setField("name", currentBidderData?.name || "");
      form.setField("mobile_number", currentBidderData?.mobile_number || "");
      form.setField("pan", currentBidderData?.pan || "");
      // form.setField("aadhar_number", currentBidderData?.aadhar_number || "");
      if (currentBidderData?.pan && currentBidderData?.name) {
        setIsNameVerified(true);
      } else {
        setIsNameVerified(false);
      }
      prevBidderData.current = currentBidderData;
    }
    // Clear any existing errors when switching steps
  }, [activeStep, currentBidderData]);

  const setFormErrorHandler = (errors = []) => {
    const allErrors: Record<string, string[]> = {};
    errors.forEach((errorObj) => {
      Object.entries(errorObj).forEach(([field, message]) => {
        if (field !== "index") {
          // Normalize field name
          const normalizedField = field === "mobile" ? "mobile_number" : field;

          allErrors[normalizedField] = [message as string];
        }
      });
    });
    form.setErrors(allErrors);
  };
  useEffect(() => {
    if (allErrorsData) {
      if (allErrorsData.length > 0) {
        const errorArray: any = [];
        allErrorsData.forEach((element: any) => {
          console.log("element: ", element, activeStep);
          if (element.index === activeStep) {
            errorArray.push(element);
          }
        });
        if (errorArray.length > 0) {
          setFormErrorHandler(errorArray);
        }
      }
    }
  }, [allErrorsData, activeStep]);

  // Internal PAN validation - called from debounced trigger
  // Does NOT clear name field (unlike the onChange version)
  const handlePanFieldValidationsInternal = async (
    e: any,
    form: any,
    setIsFetchingPan: any,
    setIsNameVerified: any,
  ) => {
    let value = (e?.target?.value || "").toString().trim().toUpperCase();

    // Don't save PAN value here - it's already saved by the trigger
    // Just verify if we have a valid PAN
    if (value.length >= 10 && panRegex.test(value)) {
      try {
        setIsFetchingPan(true);

        const payload: any = {
          card_type: "PAN",
          card_number: value,
        };

        const userName = (form.getField("name") || "").toString().trim();
        if (isDigioPanFullVerificationEnabled && userName.length >= 3) {
          payload.name = userName.toUpperCase();
        }

        const res: any = await fetchIDCardDetails(payload);
        setIsFetchingPan(false);
        await handlePANVerification(res, form, setIsNameVerified);
      } catch (error: any) {
        console.log("error:here ", error);

        if (error?.response?.status === 422) {
          const errorMessage =
            error?.response?.data?.message?.message ||
            "Validation failed. Please check your details.";
          form.pushError({
            pan: [errorMessage],
          });
        } else {
          form.pushError({
            pan: ["An internal error occurred. Please try again later."],
          });
        }
        if (!isDigioPanFullVerificationEnabled) {
          form.setField("name", "");
        }
        setIsFetchingPan(false);
        setIsNameVerified(false);
      }
    }
  };

  const handlePANVerification = async (
    panData: any,
    form: any,
    setIsNameVerified: (value: boolean) => void,
  ) => {
    if (panData) {
      const selectedType = (form.getField("user_type")?.value || "")
        .toString()
        .toLowerCase();
      const panCategory = (panData?.category || "").toString().toLowerCase();
      const panStatus = (panData?.status || "").toString().toLowerCase();
      const nameAsPerPanMatch = panData?.name_as_per_pan_match;
      const userEnteredName = (form.getField("name") || "").toString().trim();

      const isPanStatusValid = panStatus === "valid";

      const isNameLongEnough = userEnteredName.length >= 3;
      const isNameMatch = isDigioPanFullVerificationEnabled
        ? isNameLongEnough && nameAsPerPanMatch === true
        : true;

      const isValidPan = isDigioPanFullVerificationEnabled
        ? isPanStatusValid &&
          (isNameLongEnough ? nameAsPerPanMatch === true : true)
        : panStatus === "valid";

      if (panCategory !== selectedType) {
        form.pushError({
          pan: [
            selectedType === "company"
              ? "Please enter valid Company PAN"
              : "Please enter valid PAN based on bidder type",
          ],
        });
        if (!isDigioPanFullVerificationEnabled) {
          form.setField("name", "");
        }
        setIsNameVerified(false);
      } else if (!isPanStatusValid) {
        form.pushError({
          pan: ["PAN seems invalid. Please check the number and try again."],
        });
        if (!isDigioPanFullVerificationEnabled) {
          form.setField("name", "");
        }
        setIsNameVerified(false);
      } else if (!isNameMatch) {
        if (!isNameLongEnough) {
          form.pushError({
            pan: [
              "Please enter your name (minimum 3 characters) before PAN verification.",
            ],
          });
        } else {
          form.pushError({
            pan: [
              "The name doesn't match your PAN records. Please enter your name exactly as on your PAN card.",
            ],
          });
        }
        setIsNameVerified(false);
      } else {
        form.pushError({ pan: [] });
        if (!isDigioPanFullVerificationEnabled) {
          form.setField("name", panData?.full_name);
        }
        setIsNameVerified(true);
      }
    } else {
      form.setField("name", "");
      form.setField("pan", "");
      form.pushError({ pan: ["Please enter pan number"] });
      setIsNameVerified(false);
    }
  };
  const saveCurrentBidderData = () => {
    if (
      setCurrentBidderData &&
      activeStep !== undefined &&
      activeStep >= 0 &&
      activeStep < Number(totalSteps || 0)
    ) {
      const currentFormData = {
        name: form.getField("name"),
        email: form.getField("email"),
        pan: form.getField("pan"),
        mobile_number: form.getField("mobile_number"),
        // aadhar_number: form.getField("aadhar_number"),
        user_type: form.getField("user_type"),
      };

      const updatedData = [...(allBiddersData || [])];
      updatedData[activeStep] = currentFormData;
      setCurrentBidderData(updatedData);
      return updatedData;
    }
    return allBiddersData;
  };
  const handlePreviousStep = async () => {
    if (setActiveStep && activeStep && activeStep > 0) {
      // Save current form data before going to previous step
      console.log("Previous step - saving data for step:", activeStep);
      saveCurrentBidderData();
      setActiveStep(activeStep - 1);
      setAllErrorsData([]);
      clearFormErrors();
    }
  };
  const handleNextStep = async () => {
    const isValid = form.validate();
    if (!isValid) {
      return;
    }
    try {
      const payload = {
        ...form.value,
        event_uuid: eventData?.uuid,
      };
      const response: any = await handleBackendValidationsForBidderCreation(
        payload,
      );
      if (response?.is_valid) {
        setAllErrorsData([]);
        saveCurrentBidderData();
        setActiveStep(activeStep + 1);
        clearFormErrors();
      }
    } catch (error: any) {
      console.log("error: ", error);
      const errorDetails =
        error?.response?.data?.message?.errorDetails ||
        error?.response?.data?.errorDetails;

      if (errorDetails) {
        const errorData: any = [
          {
            ...errorDetails,
            index: activeStep,
          },
        ];
        setFormErrorHandler(errorData || []);
      }
    }
  };
  const handleSubmitAllBiddersData = async (
    latestAllBiddersData?: any,
  ): Promise<boolean> => {
    try {
      const event: any = await getAuctionEventById(eventData?.listing_id);
      const payload = await createJBPayload(
        event,
        latestAllBiddersData || allBiddersData,
        0,
        false,
        kycMode,
      );
      const res: any = await addBidderForEvent(payload);
      if (res?.uuid) {
        await router.replace(`/kyc/${res?.uuid}`);
        return true;
      }
      return false;
    } catch (err: any) {
      console.log("err: ", err);
      if (
        err?.response?.status === 422 &&
        err?.response?.data?.message?.message === "Identity conflict" &&
        setActiveStep
      ) {
        let errordata: any = [
          {
            index: 0,
            ...err?.response?.data?.message?.errorDetails,
          },
        ];
        setFormErrorHandler(errordata);
        return false;
      }
      if (
        err?.response?.status === 422 &&
        err?.response?.data?.message ===
          "Identity conflict(s) in joint bidders" &&
        setActiveStep
      ) {
        console.log(
          "err?.response?.data?.errors: ",
          err?.response?.data?.errors,
        );
        const data = err?.response?.data?.errors.filter(
          (detail: any) => detail?.errorDetails,
        );
        console.log("data: ", data);
        const errorData: any = [];
        for (let i = 0; i < data?.length; i++) {
          errorData.push({
            email: data[i].errorDetails.email,
            mobile_number: data[i].errorDetails.mobile,
          });
        }
        setFormErrorHandler(errorData || []);
        return false;
      }
      if (err?.response?.status === 422 && setActiveStep) {
        const errorData: any = [];
        const existingEmailsArray =
          err?.response?.data?.errorDetails?.existingEmails ?? [];
        const existingEmails =
          Array.isArray(existingEmailsArray) && existingEmailsArray.length > 0
            ? existingEmailsArray.join(", ")
            : "";
        errorData.push({
          activeStep: activeStep || 0,
          email: err?.response?.data?.errors?.email?.[0] ?? "",
          email_list: existingEmails,
        });
        setFormErrorHandler(errorData || []);
        return false;
      }
      let errordata: any = [
        {
          index: activeStep || 0,
          email: "Failed to create record. Please try again later.",
        },
      ];
      setFormErrorHandler(errordata);
      return false;
    }
  };
  const handleSubmitStep = async () => {
    // First validate the form
    setIsSubmitting(true);
    setAllErrorsData([]);
    const isValid = form.validate();
    if (!isValid) {
      setIsSubmitting(false);
      return;
    }
    try {
      const payload = {
        ...form.value,
        event_uuid: eventData?.uuid,
      };
      const response: any = await handleBackendValidationsForBidderCreation(
        payload,
      );

      if (response?.is_valid) {
        const latestAll = saveCurrentBidderData();
        const data = await jbValidateBidders(latestAll);
        if (!data.isValid) {
          //handle form errors
          setAllErrorsData(data.allErrors);
          setIsSubmitting(false);
          return;
        }
        const navigated = await handleSubmitAllBiddersData(latestAll);
        if (!navigated) {
          setIsSubmitting(false);
        }
      }
    } catch (error: any) {
      console.log(
        "Error during submission:",
        error?.response?.data?.message?.errorDetails,
      );
      // Handle error (e.g., show notification)
      // Handle backend validation errors
      const errorDetails =
        error?.response?.data?.message?.errorDetails ||
        error?.response?.data?.errorDetails;

      if (errorDetails) {
        const errorData: any = [
          {
            ...errorDetails,
            index: activeStep,
          },
        ];
        setFormErrorHandler(errorData || []);
      }
      setIsSubmitting(false);
    }
  };
  return (
    <div className="lg:px-8 lg:py-[41px] w-full lg:bg-brand-bgLightGrey">
      <div className="w-full flex flex-col gap-y-8 mt-3 lg:mt-0">
        <div className={`relative w-full`}>
          {/* {showVerifiedIcon && isVerified && (
            <div className="absolute top-1/3 right-2">
              <CheckIcon className="h-5 w-5" />
            </div>
          )} */}
          <Input
            disabled={activeStep === 0}
            type="email"
            // placeholder={"Representative PAN Number*"}
            value={form.getField("email")}
            onChange={(e) => form.setField("email", e.target.value)}
            className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-sm lg:text-web-body-md leading-3 lg:leading-4 text-brand-textLightGrey focus:border-brand-orange`}
          />
          <label
            htmlFor="email"
            className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
          >
            Email
          </label>
          {form.errors.get("email") ? (
            <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
              {form.errors.get("email")?.[0]}
            </p>
          ) : null}
        </div>

        {/* V4 mode: Name field FIRST - before PAN */}
        {isDigioPanFullVerificationEnabled && (
          <div className={`relative w-full`}>
            {isFetchingPan && (
              <div className="absolute top-1/3 right-2 z-10">
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-brand-orange"></div>
              </div>
            )}
            {isNameVerified && (
              <div className="absolute top-1/3 right-2 z-10">
                <CheckIcon className="h-5 w-5 text-green-500" />
              </div>
            )}
            <Input
              disabled={activeStep === 0}
              type="text"
              value={form.getField("name")}
              onChange={(e) => {
                const newName = e.target.value?.toUpperCase();
                form.setField("name", newName);
                // V4 name-first flow: trigger PAN verification after name >= 3 chars
                if (isDigioPanFullVerificationEnabled) {
                  triggerPanVerification();
                }
              }}
              className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-sm lg:text-web-body-md leading-3 lg:leading-4 text-brand-textLightGrey focus:border-brand-orange`}
            />
            <label
              htmlFor="name"
              className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
            >
              Name
            </label>
            {form.errors.get("name") && (
              <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                {form.errors.get("name")?.[0]}
              </p>
            )}
          </div>
        )}

        {/* PAN field - AFTER name in V4 mode, FIRST in legacy mode */}
        {!isDigioPanFullVerificationEnabled && (
          <div className={`relative w-full`}>
            {isFetchingPan && (
              <div className="absolute top-1/3 right-2 z-10">
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-brand-orange"></div>
              </div>
            )}
            <Input
              disabled={activeStep === 0}
              type="text"
              maxLength={10}
              value={form.getField("pan")}
              onChange={async (e: any) => {
                const value = e?.target?.value?.toUpperCase() || "";
                form.setField("pan", value);

                // Clear previous errors when PAN changes
                form.pushError({ pan: [] });

                // Legacy mode: clear name when PAN changes
                if (!isDigioPanFullVerificationEnabled) {
                  form.setField("name", "");
                  setIsNameVerified(false);
                }

                // Only verify if PAN is complete (10 characters)
                if (value.length === 10 && panRegex.test(value)) {
                  try {
                    setIsFetchingPan(true);
                    const res: any = await fetchIDCardDetails({
                      card_type: "PAN",
                      card_number: value,
                    });
                    await handlePANVerification(res, form, setIsNameVerified);
                  } catch (error: any) {
                    console.log("PAN verification error:", error);
                    if (error?.response?.status === 422) {
                      const errorMessage =
                        error?.response?.data?.message?.message ||
                        "Validation failed. Please check your details.";
                      form.pushError({
                        pan: [errorMessage],
                      });
                    } else {
                      form.pushError({
                        pan: [
                          "An internal error occurred. Please try again later.",
                        ],
                      });
                    }
                    form.setField("name", "");
                    setIsNameVerified(false);
                  } finally {
                    setIsFetchingPan(false);
                  }
                } else if (value.length > 0 && value.length < 10) {
                  form.setField("name", "");
                  setIsNameVerified(false);
                }
              }}
              className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-sm lg:text-web-body-md leading-3 lg:leading-4 text-brand-textLightGrey focus:border-brand-orange`}
            />
            <label
              htmlFor="pan"
              className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
            >
              Pan
            </label>
            {form.errors.get("pan") ? (
              <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                {form.errors.get("pan")?.[0]}
              </p>
            ) : null}
          </div>
        )}

        {/* Legacy mode: Name field AFTER PAN (auto-filled from API) */}
        {!isDigioPanFullVerificationEnabled && (
          <div className={`relative w-full`}>
            {isNameVerified && (
              <div className="absolute top-1/3 right-2 z-10">
                <CheckIcon className="h-5 w-5 text-green-500" />
              </div>
            )}
            <Input
              disabled={true}
              type="text"
              value={form.getField("name")}
              onChange={() => {}}
              className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-sm lg:text-web-body-md leading-3 lg:leading-4 text-brand-textLightGrey focus:border-brand-orange`}
            />
            <label
              htmlFor="name"
              className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
            >
              Name
            </label>
          </div>
        )}

        {/* V4 mode: PAN field AFTER name */}
        {isDigioPanFullVerificationEnabled && (
          <div className={`relative w-full`}>
            {isFetchingPan && (
              <div className="absolute top-1/3 right-2 z-10">
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-brand-orange"></div>
              </div>
            )}
            <Input
              disabled={
                activeStep === 0 ||
                !form.getField("name") ||
                form.getField("name").length < 3
              }
              type="text"
              maxLength={10}
              value={form.getField("pan")}
              onChange={async (e: any) => {
                const value = e?.target?.value?.toUpperCase() || "";
                form.setField("pan", value);

                // Clear previous errors when PAN changes
                form.pushError({ pan: [] });

                // Only verify if PAN is complete (10 characters)
                if (value.length === 10 && panRegex.test(value)) {
                  const userName = (form.getField("name") || "")
                    .toString()
                    .trim();
                  if (userName.length < 3) {
                    form.pushError({
                      pan: [
                        "Please enter your name (minimum 3 characters) before PAN verification.",
                      ],
                    });
                    return;
                  }

                  try {
                    setIsFetchingPan(true);
                    const res: any = await fetchIDCardDetails({
                      card_type: "PAN",
                      card_number: value,
                      name: userName.toUpperCase(),
                    });
                    await handlePANVerification(res, form, setIsNameVerified);
                  } catch (error: any) {
                    console.log("PAN verification error:", error);
                    if (error?.response?.status === 422) {
                      const errorMessage =
                        error?.response?.data?.message?.message ||
                        "Validation failed. Please check your details.";
                      form.pushError({
                        pan: [errorMessage],
                      });
                    } else {
                      form.pushError({
                        pan: [
                          "An internal error occurred. Please try again later.",
                        ],
                      });
                    }
                    setIsNameVerified(false);
                  } finally {
                    setIsFetchingPan(false);
                  }
                }
              }}
              className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-sm lg:text-web-body-md leading-3 lg:leading-4 text-brand-textLightGrey focus:border-brand-orange`}
            />
            <label
              htmlFor="pan"
              className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
            >
              Pan
            </label>
            {form.errors.get("pan") ? (
              <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                {form.errors.get("pan")?.[0]}
              </p>
            ) : null}
          </div>
        )}
        <div className={`relative w-full`}>
          {/* {showVerifiedIcon && isVerified && (
            <div className="absolute top-1/3 right-2">
              <CheckIcon className="h-5 w-5" />
            </div>
          )} */}
          <Input
            disabled={activeStep === 0}
            type="number"
            maxLength={10}
            // placeholder={"Representative PAN Number*"}
            value={form.getField("mobile_number")}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9]/g, ""); // Only allow numbers
              if (value.length <= 10) {
                form.setField("mobile_number", value);
              }
            }}
            className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-sm lg:text-web-body-md leading-3 lg:leading-4 text-brand-textLightGrey focus:border-brand-orange`}
          />
          <label
            htmlFor="mobile"
            className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
          >
            Mobile number
          </label>
          {form.errors.get("mobile_number") ? (
            <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
              {form.errors.get("mobile_number")?.[0]}
            </p>
          ) : null}
        </div>
        {activeStep == 0 && (
          <div className="flex items-center justify-between gap-3 px-4 py-2 bg-white border border-brand-textLightGrey transition-shadow duration-200">
            <div className="flex flex-col md:flex-row items-start md:items-center md:gap-3 gap-4 flex-1">
              <div className="flex flex-col gap-1 flex-1">
                <div className="flex items-center gap-2">
                  <span className="text-xs md:text-sm font-semibold text-brand-textLightGrey">
                    KYC Verification Mode
                  </span>
                  <Button
                    variant="link"
                    onClick={() => setOpenOfflineInfoModel(true)}
                    className="h-auto p-0 hover:opacity-70 transition-opacity"
                    aria-label="Learn more about KYC modes"
                  >
                    <InfoIcon className="h-4 w-4 text-brand-orange hover:text-brand-primaryActionHover transition-colors" />
                  </Button>
                </div>
                <span className="text-xs text-gray-500 tracking-tighter">
                  You are choosing{" "}
                  <span className="font-semibold text-brand-orange">
                    {kycMode === "online" ? "Online" : "Offline"}
                  </span>{" "}
                  KYC mode for verification
                </span>
              </div>
              <div className="flex items-center gap-3 px-3 py-2 bg-gray-50 rounded-md border border-gray-200">
                <span
                  className={`text-xs md:text-sm font-medium transition-colors ${
                    kycMode === "online" ? "text-brand-orange" : "text-gray-400"
                  }`}
                >
                  Online
                </span>
                <Switch
                  checked={kycMode === "online"}
                  thumbClassName="bg-white shadow-sm"
                  className="data-[state=checked]:bg-brand-orange"
                  onCheckedChange={() =>
                    setKycMode(kycMode === "online" ? "offline" : "online")
                  }
                  aria-label="Toggle KYC mode"
                />
                <span
                  className={`text-xs md:text-sm font-medium transition-colors ${
                    kycMode === "offline"
                      ? "text-brand-orange"
                      : "text-gray-400"
                  }`}
                >
                  Offline
                </span>
              </div>
            </div>
          </div>
        )}
        {/* <div className={`relative w-full`}>
          {showVerifiedIcon && isVerified && (
            <div className="absolute top-1/3 right-2">
              <CheckIcon className="h-5 w-5" />
            </div>
          )}
          <Input
            disabled={activeStep === 0}
            type="number"
            maxLength={12}
            // placeholder={"Representative PAN Number*"}
            value={form.getField("aadhar_number")}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9]/g, ""); // Only allow numbers
              if (value.length <= 12) {
                form.setField("aadhar_number", value);
              }
            }}
            className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-sm lg:text-web-body-md leading-3 lg:leading-4 text-brand-textLightGrey focus:border-brand-orange`}
          />
          <label
            htmlFor="aadhar_number"
            className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
          >
            Aadhar Number
          </label>
          {form.errors.get("aadhar_number") ? (
            <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
              {form.errors.get("aadhar_number")?.[0]}
            </p>
          ) : null}
        </div> */}
        <div className="flex justify-between md:justify-end gap-x-3">
          <Button disabled={activeStep === 0} onClick={handlePreviousStep}>
            Previous
          </Button>
          {activeStep + 1 < totalSteps && (
            <Button
              disabled={activeStep + 1 === totalSteps}
              onClick={handleNextStep}
              className="px-5"
            >
              Next
            </Button>
          )}
          {activeStep + 1 === totalSteps && (
            <Button onClick={handleSubmitStep} disabled={isSubmitting}>
              {isSubmitting ? (
                <div className="flex items-center gap-2">
                  <div className="animate-spin rounded-full h-4 w-4 border-2 border-b-transparent border-white"></div>
                  <span>Submitting...</span>
                </div>
              ) : (
                "Submit"
              )}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
